import * as React from 'react';
import { Route, Switch } from 'react-router';
import { ClubBookingsInbox } from './ClubBookingsInbox/ClubBookingsInbox';
import { ClubBookingArchive } from './ClubBookingArchive/ClubBookingArchive';

export const ClubBookingsRouting = allProps => {
  return (
    <Switch>
      <Route
        exact
        path={'/clubBookings/inbox'}
        render={props => <ClubBookingsInbox {...props} setNeedUpdate={allProps.setNeedUpdate} user={allProps.user} />}
      />
      <Route
        exact
        path={'/clubBookings/history'}
        render={props => (
          <ClubBookingArchive {...props} user={allProps.user} mode="current" setNeedUpdate={allProps.setNeedUpdate} />
        )}
      />
      <Route
        exact
        path={'/clubBookings/archive'}
        render={props => (
          <ClubBookingArchive {...props} user={allProps.user} mode="previous" setNeedUpdate={allProps.setNeedUpdate} />
        )}
      />
    </Switch>
  );
};

ClubBookingsRouting.displayName = 'ClubBookingsRouting';
